// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tiles[data-v-60205927]{background:url(/images/curators/triangles.svg) 0 0 no-repeat transparent;background-size:cover;height:300px}.hero-overlap[data-v-60205927]{margin-top:-75px}.white-border[data-v-60205927]{border:2px solid #fafafa}.black-border[data-v-60205927]{border:2px solid #212121}.stretch[data-v-60205927]{height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
